/* ============================================================
   B&M Spring Pin / Roll Pin Size Chart — table logic

   Rows are SERVER-RENDERED in sections/bm-spring-pin-chart.liquid
   (INCH view: ASME B18.8.2, 12 rows; METRIC view: B&M verified
   Pintool guide data, 5 rows), each in its own <tbody> with a
   data-keywords attribute. This script is PROGRESSIVE ENHANCEMENT
   only: it switches the inch/metric view (CSS, via data-unit on the
   table) and live-filters the existing rows. It NEVER creates data
   rows — without JS the full inch table is still in the HTML.
   ============================================================ */
(function () {
  'use strict';

  var FOOT = {
    inch: 'All dimensions in inches · D* = average diameter · chamfer features optional',
    metric: 'Metric in mm with decimal-inch equivalents · hole = ISO 286 H12 · øG = guide bore (in)'
  };

  function boot() {
    var root = document.querySelector('[data-bmchart]');
    if (!root) return;

    var table = root.querySelector('[data-size-table]') || root.querySelector('.spc-table');
    var search = root.querySelector('[data-search]');
    var countEl = root.querySelector('[data-count]');
    var footEl = root.querySelector('[data-tbl-foot]');
    var unitBtns = root.querySelectorAll('[data-unit-toggle] button');
    var tbodies = {
      inch: root.querySelector('[data-tbody="inch"]'),
      metric: root.querySelector('[data-tbody="metric"]')
    };
    var state = { q: '', unit: 'inch' };

    function dataRows(unit) {
      var tb = tbodies[unit];
      return tb ? Array.prototype.slice.call(tb.querySelectorAll('[data-row]')) : [];
    }

    function render() {
      var unit = state.unit;
      var q = state.q.trim().toLowerCase();
      var rows = dataRows(unit);
      var shown = 0;
      rows.forEach(function (tr) {
        var hay = (tr.getAttribute('data-keywords') || '').toLowerCase();
        var match = !q || hay.indexOf(q) !== -1;
        tr.hidden = !match;
        if (match) shown += 1;
      });

      // No-results row (pre-rendered + hidden in each tbody; we only toggle it,
      // never inject a new <tr>, so server rows can't be double-rendered).
      var tb = tbodies[unit];
      var norows = tb ? tb.querySelector('[data-norows]') : null;
      if (norows) {
        if (shown === 0) {
          var cell = norows.querySelector('td');
          if (cell) {
            cell.textContent = 'No sizes match "' + state.q +
              '". Try a fraction (1/8), a decimal (.250), a metric size (3mm) or a part no. (PT-125).';
          }
          norows.hidden = false;
        } else {
          norows.hidden = true;
        }
      }

      if (countEl) countEl.textContent = shown + ' / ' + rows.length + ' sizes';
      if (footEl) footEl.textContent = FOOT[unit] || FOOT.inch;
    }

    function setUnit(u) {
      if (u !== 'inch' && u !== 'metric') return;
      state.unit = u;
      if (table) table.setAttribute('data-unit', u); // CSS shows/hides the right thead + tbody
      Array.prototype.forEach.call(unitBtns, function (b) {
        var on = b.getAttribute('data-unit') === u;
        b.classList.toggle('on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      render();
    }

    Array.prototype.forEach.call(unitBtns, function (b) {
      b.addEventListener('click', function () { setUnit(b.getAttribute('data-unit')); });
    });
    if (search) {
      search.addEventListener('input', function () { state.q = search.value; render(); });
    }

    setUnit('inch');
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
